<template>
  <hm-content title="">
    <div class="table-panel flex flex-end item-center">
      <div>
        <el-input
          clearable
          v-model.trim="searchCondition.memberMobile"
          placeholder="请输入手机号"
          size="small"
          class="ipt mr10"
        ></el-input>
        <el-button type="primary" size="small" @click="search">查询</el-button>
      </div>
    </div>
    <div>
      <el-table
        stripe
        ref="table"
        :data="list"
        style="width: 100%"
        id="table"
        size="small"
      >
        <el-table-column
          type="index"
          label="序号"
          :index="(index) => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="cardNo"
          label="会员卡号"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="memberMobile"
          label="会员手机号"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="memberName"
          label="客户姓名"
        >
        </el-table-column>
        <!--<el-table-column
          header-align="center"
          align="center"
          prop="noticeNum"
          label="累计通知次数"
        ></el-table-column>-->
        <el-table-column
          header-align="center"
          align="center"
          prop="payNum"
          label="累计复购次数"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="payPrice"
          label="累计复购金额"
        >
          <template slot-scope="scope">
            ￥{{
              scope.row.payPrice
                ? toPriceNum(scope.row.payPrice.toFixed(2))
                : "0.00"
            }}
          </template>
        </el-table-column>
        <el-table-column header-align="center" align="center" label="操作">
          <template slot-scope="scope">
            <el-button
              class="blue"
              type="text"
              size="small"
              @click="details(scope.row)"
              >查看明细</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="hm-pagination">
        <el-pagination
          background
          :total="total"
          @current-change="paging"
          @size-change="handleSizeChange"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="currentPage"
        ></el-pagination>
      </div>
    </div>
  </hm-content>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      total: 0,
      list: [],
      pageSize: 10,
      currentPage: 1,
      searchCondition: {
        queryStatus: "",
        id: this.$route.query.id
      },
      type: ""
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    if (this.$route.query.queryStatus) {
      this.searchCondition.queryStatus = this.$route.query.queryStatus;
    }
    this.queryList();
  },
  methods: {
    details(row) {
      this.$router.push({
        name: "UserNotificationDetails",
        query: {
          row: JSON.stringify(row)
        }
      });
    },
    data(row) {
      this.$router.push({
        name: "PlanningData",
        query: {
          row: JSON.stringify(row)
        }
      });
    },
    add() {
      this.$router.push({
        name: "SetMessagesPush"
      });
    },
    toPriceNum(num) {
      if (isNaN(num)) {
        num = 0;
      }
      return (
        num &&
        num.toString().replace(/\d+/, function(s) {
          return s.replace(/(\d)(?=(\d{3})+$)/g, "$1,");
        })
      );
    },
    async queryList() {
      const params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      Object.assign(params, searchCondition);
      const { code, result } = await this.$store.dispatch(
        "getRepurchasePlanSendMemberList",
        params
      );
      if (code === "0") {
        const { total, records } = result;
        this.list = records;
        this.total = total;
      }
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    }
  }
};
</script>
<style lang='scss' scoped>
</style>
